import React, { useState } from "react";
import { Clapperboard, ChevronDown } from "lucide-react";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
  DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { api } from "@/lib/api";
import { toast } from "sonner";

const SCENARIOS = [
  { id: "match_day_critical", label: "Match-Day Critical Cascade", steps: 8, hint: "Congestion → Fight → Stampede → Fire → Surge" },
  { id: "vip_escort",         label: "VIP Escort Threat",          steps: 4, hint: "Vehicle → Climb → Proximity → Intrusion" },
  { id: "egress",             label: "Post-Match Egress",          steps: 5, hint: "Congestion → Queue → Fall → Surge" },
];

export const DemoDirector = () => {
  const [running, setRunning] = useState(null);

  const run = async (id) => {
    setRunning(id);
    try {
      const res = await api.runScenario(id);
      toast(`Scenario "${id}" launched`, {
        description: `${res.steps} events firing over the next ~${res.steps * 3}s`,
      });
    } catch {
      toast.error("Could not start scenario");
    } finally {
      setTimeout(() => setRunning(null), 25_000);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="btn-tac-primary" data-testid="demo-director-btn" disabled={!!running}>
          <Clapperboard className="w-3.5 h-3.5" />
          {running ? "Running…" : "Demo Director"}
          <ChevronDown className="w-3 h-3 opacity-60" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="w-80 border border-border bg-[hsl(var(--surface-elevated))]"
        style={{ borderRadius: 2 }}
      >
        <DropdownMenuLabel className="font-display uppercase tracking-tight text-xs">
          Scripted Scenarios
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {SCENARIOS.map((s) => (
          <DropdownMenuItem
            key={s.id}
            onSelect={() => run(s.id)}
            className="flex flex-col items-start gap-0.5 py-2 cursor-pointer"
            data-testid={`scenario-${s.id}`}
          >
            <div className="font-display font-bold uppercase tracking-tight text-xs">{s.label}</div>
            <div className="font-mono text-[10px] text-muted-foreground">{s.hint}</div>
            <div className="font-mono text-[10px] sev-low">{s.steps} steps</div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default DemoDirector;
